import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Lang } from '../types/content';
const languages: {
  code: Lang;
  label: string;
  name: string;
}[] = [{
  code: 'et',
  label: 'ET',
  name: 'Eesti'
}, {
  code: 'ru',
  label: 'RU',
  name: 'Русский'
}, {
  code: 'en',
  label: 'EN',
  name: 'English'
}];
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="flex rounded-full border border-line bg-linen p-0.5" role="group" aria-label="Language" data-id="element-210" data-mp="3vnv3r9qsckxa">
      {languages.map(item => <button key={item.code} type="button" onClick={() => setLang(item.code)} aria-pressed={lang === item.code} aria-label={item.name} className={`rounded-full px-2.5 py-1 text-xs font-bold transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-hay ${lang === item.code ? 'bg-bark text-cream' : 'text-bark/70 hover:text-bark'}`} data-id="element-211" data-mp="4epdz9vqbd6q">
          {item.label}
        </button>)}
    </div>;
}